export const GOOGLE_MARKER_SIGNATURE = 'Google marker';

export const DEFAULT_MAP_CENTER = { lat: 37.444585, lng: 65.607399 };
export const DEFAULT_MAP_ZOOM = 4;

export const MAP_WIDGET_TYPES = {
  popup: 'popup'
} as const;
